export default "__VITE_ASSET__BNbAYcWZ__"